import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=dc50e4ca&"
import script from "./BannerView.vue?vue&type=script&lang=js&"
export * from "./BannerView.vue?vue&type=script&lang=js&"
import style0 from "./BannerView.vue?vue&type=style&index=0&id=dc50e4ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports